$(document).on('turbolinks:load', function() {
  $(document).on('show.bs.collapse', '.collapse', function() {
    const collapseId = $(this).attr('id');
    const header = $(this).siblings('.card-header').find(`[data-target="#${collapseId}"]`);
    if (header.length) {
      header.find('i').removeClass('mdi-chevron-down').addClass('mdi-chevron-up');
    }
  });

  $(document).on('hide.bs.collapse', '.collapse', function() {
    const collapseId = $(this).attr('id');
    const header = $(this).siblings('.card-header').find(`[data-target="#${collapseId}"]`);
    if (header.length) {
      header.find('i').removeClass('mdi-chevron-up').addClass('mdi-chevron-down');
    }
  });

  $(document).on('change', '.division-filter-select', function() {
    const form = $(this).closest('form')[0];
    const url = form.action;
    const divisionId = $(this).val();
    $.get(`${url}?division_id=${divisionId}`);
  });
});
